import React from "react";
import { useNavigate } from "react-router-dom";
import Onboarding from "../onboarding/Onboarding";
import Container from "../Container";
import Page from "../Page";
import { User } from "../../modules/users/types";

interface OnboardingPageProps {
  user: User;
}

const OnboardingPage: React.FunctionComponent<OnboardingPageProps> = () => {
  const navigate = useNavigate();

  const handleComplete = () => {
    navigate("/");
  };

  return (
    <Page>
      <Container>
        <Onboarding onComplete={handleComplete} />
      </Container>
    </Page>
  );
};

export default OnboardingPage;
